import React from "react";
import { Box, Paper, Typography, makeStyles } from "@material-ui/core";
import { Icon } from "./ds";
import tokens from "./designTokens";

const TONES = {
  default: { bg: tokens.primaryLight, fg: tokens.primary },
  error: { bg: "#FDECEA", fg: tokens.error },
  green: { bg: "#E6F6EE", fg: "#0B8A4B" },
  warn: { bg: "#FFF6E0", fg: "#B07B00" },
};

const useStyles = makeStyles({
  strip: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    border: `1px solid ${tokens.border}`,
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(16,24,40,.04)",
    overflow: "hidden",
  },
  seg: {
    flex: "1 1 150px",
    display: "flex",
    alignItems: "center",
    gap: 13,
    padding: "16px 20px",
    borderRight: `1px solid ${tokens.border}`,
    marginRight: -1,
  },
  segIcon: {
    width: 42,
    height: 42,
    borderRadius: 21,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  value: {
    fontFamily: tokens.fontHeading,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.15,
    color: "#232D2F",
    fontVariantNumeric: "tabular-nums",
  },
  label: { fontFamily: tokens.fontBody, fontSize: 12, fontWeight: 600, color: tokens.textSecondary, marginTop: 2 },
  sub: { fontFamily: tokens.fontBody, fontSize: 11, color: tokens.textHint, marginTop: 1 },
});

// One bordered strip, segments divided by hairlines — the KPI ribbon.
export function KpiStrip({ children, testid }) {
  const classes = useStyles();
  return (
    <Paper variant="outlined" className={classes.strip} data-testid={testid}>
      {children}
    </Paper>
  );
}

export default function KpiTile({ icon, label, value, sub, tone = "default", valueColor, loading, testid }) {
  const classes = useStyles();
  const t = TONES[tone] || TONES.default;
  return (
    <Box className={classes.seg} data-testid={testid}>
      <Box className={classes.segIcon} style={{ backgroundColor: t.bg, color: t.fg }}>
        <Icon name={icon} size={20} />
      </Box>
      <Box minWidth={0}>
        <Typography component="div" className={classes.value} style={valueColor ? { color: valueColor } : undefined}>
          {loading ? "…" : value}
        </Typography>
        <Typography component="div" className={classes.label}>{label}</Typography>
        {sub && <Typography component="div" className={classes.sub}>{sub}</Typography>}
      </Box>
    </Box>
  );
}
